<template>
  <router-view/>
</template>

<script>
export default {
  name: 'Transaksi'
}
</script>
